import React from 'react'
import Icon from 'components/elements/Icon'

import Link from 'components/elements/Link'

import styles from './header.module.scss'

type Props = {
  main: string
} & (
  | { secondary: React.ReactNode; href: string; onClick?: never }
  | { secondary: React.ReactNode; href?: never; onClick: (e?: React.MouseEvent) => void }
  | { secondary: React.ReactNode; href?: never; onClick?: never }
  | { secondary?: never; href?: never; onClick?: never }
)

const Header = ({ main, secondary, href, onClick }: Props) => (
  <div className={styles.container}>
    <h3 id={main.replace(' ', '_')}>{main}</h3>

    {href && secondary && (
      <Link href={href}>
        {secondary} <Icon name="arrow right" />
      </Link>
    )}

    {onClick && secondary && (
      <button onClick={onClick}>
        {secondary} <Icon name="arrow right" />
      </button>
    )}

    {!href && !onClick && secondary && secondary}
  </div>
)

export default Header
